export default __webpack_public_path__ + "static/media/neirong.df1f1f29.jpg";